import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zipCode'
})
export class ZipCodePipe implements PipeTransform {
  /**
   *
   * @param value Transform value to inlcude the dashes
   * @param args
   */
  transform(value: any, args?: any): any {
    let fieldValue = value.toString();

    // if dashes already exist all of them
    fieldValue = fieldValue.split('-').join('');

    if (fieldValue.length <= 5) {
      return fieldValue;
    } else {
      return fieldValue.substr(0, 5) + '-' + fieldValue.substr(5);
    }
  }

  /**
   *
   * @param value Function to remove dashes and return string
   */
  parse(value: string) {
    if (value === undefined || value === null) {
      return value;
    }
    return value.split('-').join('');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/zip-code.pipe.ts